<template>
  <v-autocomplete
    v-bind="bindStyle"
    :item-text="itemText"
    :item-value="itemValue"
    :value="value"
    dense
    @input="emitValue"
    multiple
    :items="resolvedItems"
    hide-details
    class="general-selector">
    <template #prepend-inner
      ><span class="font-weight-medium text-no-wrap" v-if="value && value.length && $attrs.label"
        >{{ $attrs.label }}:
      </span>
      <v-icon size="18" v-else>mdi-filter-outline</v-icon>
    </template>
    <template v-slot:selection="{ item, index }">
      <span v-if="index === 0">{{ item[itemText] }}</span>
      <span v-if="index === 1" class="grey--text text-caption ml-1">
        (+{{ value.length - 1 }})
      </span>
    </template>
    <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
  </v-autocomplete>
</template>

<script>
  import httpService from '@Utils/httpService';

  export default {
    props: {
      value: {
        type: Array,
        default: () => [],
      },
      url: {
        type: String,
      },
      itemText: {
        type: String,
        default: 'name',
      },
      itemValue: {
        type: String,
        default: 'id',
      },
      defaultStyle: {
        type: Object,
        default: () => ({ solo: true, clearable: true }),
      },
      // When provided (non-null), the PARENT owns the option list and this
      // component does NOT fetch from `url`. Backward compatible: omit it
      // (defaults to null) to keep the original fetch-from-url behaviour.
      items: {
        type: Array,
        default: null,
      },
    },
    computed: {
      bindStyle() {
        return Object.assign({}, this.defaultStyle, this.$attrs);
      },
      // Parent-provided `items` win; otherwise fall back to the locally fetched list.
      resolvedItems() {
        return this.items !== null ? this.items : this.localItems;
      },
    },
    data() {
      return {
        localItems: [],
      };
    },
    methods: {
      emitValue(val) {
        this.$emit('input', val);
      },
    },
    mounted() {
      // Only self-fetch when the parent did not supply `items` (and a url exists).
      if (this.items !== null || !this.url) return;
      httpService
        .get({
          url: this.url,
        })
        .then((res) => {
          this.localItems = res.data.item || res.data;
        });
    },
  };
</script>

<style lang="scss">
  .general-selector {
    &.input-height-36 {
      .v-input__control {
        min-height: 36px !important;
      }
    }
    &.v-autocomplete.v-select input {
      min-width: 60px;
      width: 70px;
    }
    &.v-autocomplete.v-select.v-input--is-dirty input {
      min-width: 20px;
      width: 20px;
    }
  }
</style>
